import { Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { INextButtonProps } from "./SelectProductRangeInterfaces";
import { ModelState } from "../../routing/RoutingStates";

export default function NextButton({
  productRangeState,
  selectedProductRange,
}: INextButtonProps) {
  const navigate = useNavigate();
  const handleNext = () => {
    const modelState: ModelState = {
      isProductCompany: productRangeState.isProductCompany,
      selectedCompany: productRangeState.selectedCompany,
      selectedProductRange: selectedProductRange,
    };
    navigate("SelectModel", {
      state: { modelState },
    });
  };
  if (selectedProductRange === null) {
    return <></>;
  }
  return (
    <Row>
      <Col className="d-flex justify-content-end">
        <Button className="btn btn-primary" onClick={handleNext}>
          Next
        </Button>
      </Col>
    </Row>
  );
}
